import React, { useEffect, useState } from 'react'
// import {ColorRing} from 'react-loader-spinner'
import './PageLoading.scss'
import {toAbsoluteUrl} from '../../_metronic/helpers'
import './ScrollingText.scss'; // make sure to create this ScrollingText.scss file

const PageLoadingSend = ({typeSend}: {typeSend: string}) => {

  const [messages, setMessages] = useState([''])

  useEffect(() => {
    switch (typeSend) {
      case 'review':
        setMessages([
          "Reviewing Campaign",
          "Loading Contact List",
          "Counting Credits",
          "Summarising Campaign Details",
        ])
        break;
      case 'send':
        setMessages([
          "Scheduling Campaign",
          "Connecting with Carrier",
          "Uploading User Data",
          "Pushing Campaign Live"
        ])
        break;
    
      default:
        break;
    }

    return () => setMessages([])
  }, [typeSend])

  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
          zIndex: '9999',
          backgroundColor: ' rgba(255,255,255,0.70)',
        }}
      >
        <div className='loaderwrapper'>
        <img src={toAbsoluteUrl('/media/misc/spinner200.gif')} alt='img' width={100} />
        <img src={toAbsoluteUrl('/media/misc/cellcast.svg')} alt='cellcast' style={{marginTop: '2pt'}} />
        <div className="scrolling-text-container">
          <div className="scrolling-text">
            {messages.map((message, index) => (
              <div key={index} className="message">
                {message}
              </div>
            ))}
            {/* Duplicate messages for a seamless loop */}
            {messages.map((message, index) => (
              <div key={`duplicate-${index}`} className="message">
                {message}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default PageLoadingSend
